import { IMetricsContent } from "./alert";

export interface IAdhocSearch {
  searchId: string;
  image: any;
  provider: string;
  email: string;
}

export const initialAdhocSearch: IAdhocSearch = {
  searchId: "",
  image: "",
  provider: "",
  email: ""
}

// Image upload interfaces
export interface IImageStatusType {
  [key: string]: { status: 'UPLOADING' | 'SUCCESS' | 'FAILED' };
}

export interface IUploadImageSettings {
  searchId: string;
  base64: string;
  provider: string;
}

export interface IMatchesStats {
  manual: {
    dailyMatches: IMetricsContent[],
    dailySearches: IMetricsContent[],
    totalMatches: number;
    agenciesSearches: IMetricsContent[];
    agenciesMatches: IMetricsContent[];
    providersSearches: IMetricsContent[];
    providersMatches: IMetricsContent[];
    results: number;
  },
  automatic: {
    daily: IMetricsContent[];
    results: number;
  }
}

export const initialMatchesStats: IMatchesStats = {
  manual: {
    dailyMatches: [],
    dailySearches: [],
    totalMatches: 0,
    agenciesSearches: [],
    agenciesMatches: [],
    providersSearches: [],
    providersMatches: [],
    results: 0
  },
  automatic: {
    daily: [],
    results: 0
  }
}



// WEBPACK FOOTER //
// ./src/share/types/adhoc.ts